export default __webpack_public_path__ + "static/media/christopher-gower-m_HRfLhgABo-unsplash.1219d393.jpg";